import { combineReducers } from 'redux';
import change from './change';

export default combineReducers({ change });
